import { CopyOutlined, LeftOutlined, LoadingOutlined, PlusOutlined, RightOutlined } from '@ant-design/icons';
import React, { useState, useEffect, useContext } from 'react';
import { Spin, message } from 'antd';
import AppContext from '../../context/AppContext';
import { handleDescriptionRequest } from '../../firebase/genDescription';

const words = ["transcription", "description", "title", "tags"];


const DescriptionComponent = () => {
    // const [currentDescription, setCurrentDescription] = useState("Join me on an epic adventure as I spend 48 hours deep in the jungle of Sumatra, Indonesia. From trekking through dense rainforest to spotting exotic wildlife, I'll take you on a thrilling journey through one of the world's most biodiverse ecosystems. Get ready for stunning scenery, heart-pumping action, and unforgettable encounters with the natural world. #SumatraJungle #IndonesiaTravel #AdventureTime");
    const [allDescriptions, setAllDescriptions] = useState(["Join me on an epic adventure as I spend 48 hours deep in the jungle of Sumatra, Indonesia. From trekking through dense rainforest to spotting exotic wildlife, I'll take you on a thrilling journey through one of the world's most biodiverse ecosystems. Get ready for stunning scenery, heart-pumping action, and unforgettable encounters with the natural world. #SumatraJungle #IndonesiaTravel #AdventureTime", "asdsf", "another new title", "you generated a youtube title"]);
    const {
        currentDescription,
        setDescription,
        generatedDescriptions,
        setGeneratedDescriptions,
        descriptionLoading,
        setDescriptionLoading,
        transcriptionText
    } = useContext(AppContext)

    useEffect(() => {
        const intervalId = setInterval(() => {
            setTimeout(() => {
                // setIndex((prevIndex) => (prevIndex + 1) % words.length);
                // setFade(false);
            }, 200); // Wait for fade out, then change word
        }, 1000); // Change every 3 seconds

        return () => clearInterval(intervalId);
    }, []);

    const copyToClipboard = () => {
        if (currentDescription) {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                // Modern browsers
                navigator.clipboard.writeText(currentDescription)
                    .then(() => {
                        message.success('Description copied to clipboard');
                    })
                    .catch(err => {
                        fallbackCopyTextToClipboard(currentDescription);
                    });
            } else {
                // Fallback for older browsers and some mobile devices
                fallbackCopyTextToClipboard(currentDescription);
            }
        }
    };

    const fallbackCopyTextToClipboard = (text) => {
        const textArea = document.createElement("textarea");
        textArea.value = text;

        // Make the textarea out of viewport
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            const successful = document.execCommand('copy');
            if (successful) {
                message.success('Description copied to clipboard');
            } else {
                message.error('Failed to copy Description');
            }
        } catch (err) {
            message.error('Failed to copy Description');
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
    };

    const displayCopyIcon = () => {
        // if (generatedDescriptions.length > 0) {
        return (
            <div style={{ paddingLeft: "16px" }}>
                <CopyOutlined onClick={copyToClipboard} style={{ fontSize: "24px", color: "#777777" }} />
            </div>
        )
        // } else {
        // return null
        // }
    }

    const displayLeftIcon = () => {
        const currentIndex = generatedDescriptions?.indexOf(currentDescription) ?? 0;
        if (generatedDescriptions?.length > 0 && currentIndex !== 0) {
            return (
                <div style={{ paddingLeft: "16px" }}>
                    <LeftOutlined onClick={selectPrevious} style={{ fontSize: "24px", color: "#777777" }}></LeftOutlined>
                </div>
            )
        } else {
            return null
        }
    }

    const handleAddDescription = async () => {
        try {
            setDescriptionLoading(true)
            // Generate initial title
            const initialDescription = await handleDescriptionRequest(transcriptionText);
            // const initialDescription = "add a new title"
            setDescriptionLoading(false);
            setDescription(initialDescription)
            setGeneratedDescriptions([...generatedDescriptions, initialDescription]);
            return initialDescription
        } catch (error) {
            if (error.message === 'Insufficient credits') {
                message.error("Buy credits on the account page")
            } else {
                message.error("Failed to generate a description")
            }
            console.error('Error generating a description:', error);
            setDescriptionLoading(false);
        }
    }

    const displayRightIcon = () => {
        if (currentDescription === generatedDescriptions?.[generatedDescriptions.length - 1]) {
            return (
                <div style={{ paddingLeft: "16px" }}>
                    <PlusOutlined onClick={handleAddDescription} style={{ fontSize: "24px", color: "#777777" }}></PlusOutlined>
                </div>
            )
        } else if (generatedDescriptions?.length < 1 && transcriptionText !== 'Input a video at the top place to get your video transcription and subtitle file') {
            return (
                <div style={{ paddingLeft: "16px" }}>
                    <PlusOutlined onClick={handleAddDescription} style={{ fontSize: "24px", color: "#777777" }}></PlusOutlined>
                </div>
            )
        } else if (generatedDescriptions?.length < 1) {
            return null
        } else {
            return (
                <div style={{ paddingLeft: "16px" }}>
                    <RightOutlined onClick={selectNext} style={{ fontSize: "24px", color: "#777777" }}></RightOutlined>
                </div>
            )
        }
    }

    const displayLoading = () => {
        return (
            <div style={{ alignItems: "center", display: "flex" }}>
                <Spin indicator={<LoadingOutlined spin />} style={{ paddingRight: "16px" }} /> Loading...
            </div>
        )
    }

    const selectPrevious = () => {
        const currentIndex = generatedDescriptions.indexOf(currentDescription) ?? 0;

        if (currentIndex !== -1) {
            const previousIndex = (currentIndex - 1 + generatedDescriptions?.length) % generatedDescriptions?.length;
            setDescription(generatedDescriptions[previousIndex]);
        }
    }
    const selectNext = () => {
        const currentIndex = generatedDescriptions.indexOf(currentDescription);

        if (currentIndex !== -1) {
            const nextIndex = (currentIndex + 1) % generatedDescriptions?.length;
            setDescription(generatedDescriptions[nextIndex]);
        }
    }

    return (
        <div>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                <h2 style={{ color: "#3C3C3C" }}>Description</h2>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    {displayCopyIcon()}
                    {displayLeftIcon()}
                    {displayRightIcon()}
                </div>
            </div>
            <div style={{
                border: "solid lightgray 1px", borderRadius: "8px", backgroundColor: "white", width: "100%", padding: "16px",
                maxHeight: "450px",
                overflowY: "auto"
            }}>
                <style>
                    {`
        /* Webkit browsers like Chrome, Safari */
        div::-webkit-scrollbar {
            width: 8px;
        }
        div::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }
        div::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;
        }
        div::-webkit-scrollbar-thumb:hover {
            background: #555;
        }

        /* Firefox */
        div {
            scrollbar-width: thin;
            scrollbar-color: #888 #f1f1f1;
        }
        `}
                </style>
                <span style={{ fontSize: "16px", fontWeight: "500", color: "#3C3C3C" }}>{descriptionLoading ? displayLoading() : (
                    <div style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#3C3C3C",
                        whiteSpace: "pre-line",
                        wordBreak: "break-word",
                        overflowWrap: "break-word"
                    }}>
                        {currentDescription.split('\n').map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                {index < currentDescription.split('\n').length - 1 && <br />}
                            </React.Fragment>
                        ))}
                    </div>
                )}</span>
            </div>
        </div>
    );
};

export default DescriptionComponent;